import PropTypes from 'prop-types';

import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const ArticlesByTagCategoryHeading = ({
  categoryName = null,
  tagName = null,
}) => (
  <div className="mx-4 lg:mx-0">
    <Breadcrumb>
      <BreadcrumbItem href={LINKS.HOME}>
        {placeholder('breadcrumbs.promobit')}
      </BreadcrumbItem>
      <BreadcrumbItem href={LINKS.BLOG}>
        {placeholder('breadcrumbs.blog')}
      </BreadcrumbItem>
      <BreadcrumbItem>{categoryName || tagName}</BreadcrumbItem>
    </Breadcrumb>
  </div>
);

ArticlesByTagCategoryHeading.propTypes = {
  categoryName: PropTypes.string,
  tagName: PropTypes.string,
};

export default ArticlesByTagCategoryHeading;
